import type { AddSessionResponse } from '@/services/oauth';
import type { Session } from '@customerio/hydra-session-state';

/**
 * Merge a SAML add_session payload (which only contains the newly added
 * session, because SameSite=Lax hides existing cookies on the cross-site IdP
 * POST) with the existing sessions list. Dedupes by `id`. Ported from the
 * Ember `mergeSAMLSessionWithLocal`.
 */
export function mergeSamlSessionWithLocal(
  payload: AddSessionResponse,
  existingSessions: Session[],
): AddSessionResponse {
  const byId = new Map<number, AddSessionResponse['sessions'][number]>();
  for (const session of existingSessions) {
    byId.set(session.id, session);
  }
  for (const session of payload.sessions) {
    byId.set(session.id, session);
  }
  return {
    session_index: payload.session_index,
    sessions: Array.from(byId.values()),
  };
}
